import MainLayout from "../../components/layouts/MainLayout"
import React, { useEffect, useState } from "react";
import { DeleteFilled, EditFilled, EyeFilled, PlusOutlined, ReloadOutlined } from "@ant-design/icons";
import { Auth } from "../../utils/Auth";
import { message, Spin, Tooltip } from "antd";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { annonceApi } from "../../api/annonceApi";
import { DateFormat } from "../../utils/formatDate";
import Money from "../../components/Money";

const ListAnnouncementsView = () =>{

    const token = Auth.getSessionToken()
    const abortController = new AbortController()
    const [annonces, setAnnonces] = useState([])
    const [loading, setLoading] = useState(false)
    const navigate = useNavigate()
    const [isExpired, setIsExpired] = useState('');
    const [formattedDate, setFormattedDate] = useState('');
    const [annonceDate, setAnnonceDate] = useState('');
    const itemsPerPage = 15
    const [currentPage, setCurrentPage] = useState(1)
    const now = new Date();
    const date_now = now.getFullYear() + "-" + 
          String(now.getMonth() + 1).padStart(2, "0") + "-" + 
          String(now.getDate()).padStart(2, "0") + " " + 
          String(now.getHours()).padStart(2, "0") + ":" + 
          String(now.getMinutes()).padStart(2, "0") + ":" + 
          String(now.getSeconds()).padStart(2, "0");

    
    const handlefetchdata = async () => {
        setLoading(true)

        try {
            const res = await annonceApi.getAnnouncements(abortController.signal)
          

            if(!res){
                setLoading(false)
                   return;

            }            
            
            setAnnonces(res.data)
            setLoading(false)

         } catch (error) {
             console.log(error)

            setLoading(false)
            const messages = await error.messages ?? error.message;

          if(messages instanceof Array)
              return Swal.fire({
                title:messages.join('\n')!== 'Unauthenticated' ? "Erreur détectée" : "Session expirée",
                text:messages.join('\n')!== 'Unauthenticated' ? "Veuillez vous reconncter."  :  "Votre session a expirée veuillez vous reconnecter",
                icon:"error",
              }).then((result) => {
                if(messages.join('\n') === 'Unauthenticated'){
                    Auth.removeSessionToken()
                    return navigate(`/login`)
                }   
                        
              });

         }
    }

    const handleDetail = (annonce) => {
        if(annonce.id)
            return navigate(`/annonce/${annonce.id}/details`)
    }

    const handleDetailQuiz = (annonce) => {
        if(annonce.id)
            return navigate(`/annonce/${annonce.id}/details-quiz`)
    }

    const handleEdit = (annonce) => {
        if(annonce.id)
            return navigate(`/annonce/${annonce.id}/edit`)
    }

    const handleAddAnnonce = () => {
        return navigate(`/annonce/ajouter`)
    }

    const handleReactivate = async (annonce) => {
        // Vérifier si l'annonce est expirée
        const isExpired = annonce?.expired_at < date_now;
        
        if (!isExpired) {
            return message.warning("Cette annonce est déjà active");
        }

        // Afficher la modale avec option de délai d'expiration
        const { value: formValues } = await Swal.fire({
            title: 'Réactiver l\'annonce',
            html: `
                <div style="text-align: left;">
                    <p style="margin-bottom: 10px;">Voulez-vous définir une nouvelle date d'expiration ?</p>
                    <label style="display: block; margin-bottom: 5px; font-weight: 500;">Date d'expiration (optionnel) :</label>
                    <input 
                        id="delay_expiration" 
                        type="datetime-local" 
                        class="swal2-input" 
                        placeholder="Laisser vide pour réactiver sans expiration"
                        style="width: 100%; padding: 8px; border: 1px solid #ddd; border-radius: 4px;"
                    />
                    <p style="margin-top: 10px; font-size: 12px; color: #666;">
                        Laissez vide pour réactiver sans date d'expiration
                    </p>
                </div>
            `,
            focusConfirm: false,
            showCancelButton: true,
            confirmButtonText: 'Réactiver',
            cancelButtonText: 'Annuler',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            preConfirm: () => {
                const delayExpiration = document.getElementById('delay_expiration').value;
                return {
                    delay_expiration: delayExpiration || ""
                };
            }
        });

        if (formValues) {
            try {
                setLoading(true);
                const res = await annonceApi.reactivateAnnonce(
                    annonce.id,
                    formValues.delay_expiration,
                    abortController.signal
                );

                if (!res.success) {
                    return Swal.fire({
                        title: "Erreur",
                        text: res.message || "Impossible de réactiver l'annonce",
                        icon: "error",
                    });
                }

                message.success("Annonce réactivée avec succès");
                handlefetchdata(); // Rafraîchir la liste
            } catch (error) {
                console.error(error);
                message.error("Une erreur est survenue lors de la réactivation");
                const messages = await error.messages ?? error.message;

                if (messages instanceof Array) {
                    return Swal.fire({
                        title:
                            messages.join("\n") !== "Unauthenticated"
                                ? "Erreur détectée"
                                : "Session expirée",
                        text:
                            messages.join("\n") !== "Unauthenticated"
                                ? "Veuillez vous reconnecter."
                                : "Votre session a expirée veuillez vous reconnecter",
                        icon: "error",
                    }).then((result) => {
                        if (messages.join("\n") === "Unauthenticated") {
                            Auth.removeSessionToken();
                            return navigate(`/login`);
                        }
                    });
                }
            } finally {
                setLoading(false);
            }
        }
    };

    const handleDelete = async (annonce) => {
        try {
            const res = await annonceApi.deleteAnnouncement(`${annonce.id}`,abortController.signal)

            if (res.success == true) {
                message.success("Suppression effectuee avec succès !");
            }else{
                message.error(res.message);

            }

            handlefetchdata()
            
        } catch (error) {
            console.error(error);
            setLoading(false);
            message.error("Échec de suppression des informations");
        }
    }
    
    const indexOfLastItem = currentPage * itemsPerPage
    const indexOfFirstItem = indexOfLastItem - itemsPerPage
    const currentItems = annonces.slice(indexOfFirstItem, indexOfLastItem);

    const paginate = (pageNumber) => setCurrentPage(pageNumber);
    
    useEffect(() => {
            handlefetchdata()
        },[])
    
    return <MainLayout>
        <div className="container mx-auto p-4">
                <div className="flex justify-between items-center"> 
                    <h1 className="text-xl font-bold mb-4">Liste des annonces</h1>
        
                    {/* Bouton Ajouter */}
                    <button
                        onClick={handleAddAnnonce}
                        className="px-4 py-2 text-white bg-africasa-secondary rounded hover:bg-africasa-primary flex items-center"
                    >
                        <PlusOutlined className="mr-2" />
                        Ajouter une annonce
                    </button>
                </div>
        
                {/* Table */}
                <table className="min-w-full bg-white border border-gray-300">
                  <thead>
                    <tr className="bg-gray-200">
                      <th className="py-2 px-4 border-b text-left">#</th>
                      <th className="py-2 px-4 border-b text-left">Titre</th>
                      <th className="py-2 px-4 border-b text-left">Categorie</th>
                      <th className="py-2 px-4 border-b text-left">Prix</th>
                      <th className="py-2 px-4 border-b text-left">Status</th>
                      <th className="py-2 px-4 border-b text-left">Nombre de vue</th>
                      <th className="py-2 px-4 border-b text-left">Likes</th>
                      <th className="py-2 px-4 border-b text-left">Signal comme abus</th>
                      <th className="py-2 px-4 border-b text-left">Publie le</th>
                      <th className="py-2 px-4 border-b text-left">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                        <tr>
                        <td colSpan="10" className="text-sm text-center py-4">
                            Chargement des données en cours...
                        </td>
                        </tr>
                    ) : (
                      currentItems.map((annonce, index) => {
                        const isExpired = annonce?.expired_at < date_now;
                        return (
                        <tr key={annonce.id}>
                            <td className="py-2 px-4 border-b">{++index}</td>
                            <td className="py-2 px-4 border-b">
                            {annonce?.title} 
                            </td>
                            <td className="py-2 px-4 border-b">{annonce?.category?.libelle || ''}</td>
                            <td className="py-2 px-4 border-b">{annonce?.price ? <Money amount={annonce.price} /> : ''}</td>
                            <td className="py-2 px-4 border-b">
                              
                                {!isExpired ? (
                                    <span className="badge bg-green-600 text-white text-sm rounded-md p-1 flex items-center content-center">
                                        Active
                                    </span>
                                ) : (
                                    <span className="badge bg-red-600 text-white text-sm rounded-md p-1 flex items-center content-center">
                                        Expiree
                                    </span>
                                )}
                            </td>
                            <td className="py-2 px-4 border-b">{annonce?.views || 0}</td>
                            <td className="py-2 px-4 border-b">{annonce?.likes || 0}</td>
                            <td className="py-2 px-4 border-b">{annonce?.abus || 0}</td>
                            <td className="py-2 px-4 border-b">{DateFormat.formatDate(annonce?.created_at)  }</td>
                            
                            <td className="py-2 px-4 border-b">
                                <div className="flex items-center gap-2">
                                    <Tooltip title="Details de l'annonce">
                                        <EyeFilled
                                            className="text-green-600 cursor-pointer hover:text-green-800"
                                            onClick={() => handleDetail(annonce)}
                                        />
                                    </Tooltip>
                                   
                                    {/* Icône Modifier */}
                                    <Tooltip title="Modifier">
                                        <EditFilled 
                                            className="text-blue-600 cursor-pointer hover:text-blue-800" 
                                            onClick={() => handleEdit(annonce)}
                                        />
                                    </Tooltip>
                                    
                                    {/* Icône Réactiver - uniquement pour les annonces expirées */}
                                    {isExpired && (
                                        <Tooltip title="Réactiver l'annonce">
                                            <ReloadOutlined 
                                                className="text-orange-600 cursor-pointer hover:text-orange-800" 
                                                onClick={() => handleReactivate(annonce)}
                                            />
                                        </Tooltip>
                                    )}
                                    
                                    {/* Icône Supprimer */}
                                    <Tooltip title="Supprimer">
                                        <DeleteFilled 
                                            className="text-red-600 cursor-pointer hover:text-red-800"
                                            onClick={() => handleDelete(annonce)}
                                        />
                                    </Tooltip>
                                </div>
                            </td>
                        </tr>
                        )
                      })
                    )}
                    </tbody>
        
                </table>
                <div className="flex ml-0 space-x-2 mt-2 justify-end">
                    {Array.from({ length: Math.ceil(annonces.length / itemsPerPage) }, (_, i) => (
                        <button 
                            key={i} 
                            onClick={() => paginate(i + 1)}
                            className={`px-3 py-1 border rounded ${currentPage === i + 1 ? 'bg-blue-500 text-white' : 'bg-gray-200'}`}
                        >
                            {i + 1}
                        </button>
                    ))}
                </div>
              </div>
    </MainLayout>
}
export default ListAnnouncementsView